// extracted by mini-css-extract-plugin
export default {"buttonBack":"styles_buttonBack__PyJsb","buttonBack__arrow":"styles_buttonBack__arrow__Lz-K3"};